import { audios, videos } from '@/utils/data'
export default {
  data () {
    return {
      videos: Object.freeze(videos),
      audios: Object.freeze(audios),
      // 轮播图
      currentCarouselIndex: 0,
      videoPlayState: false,
      // 故事列表
      currentStoryIndex: 0,
      storyPlayState: false,
      speed: 1,
      totalAudioDuration: '12: 30', // 总时长
    }
  },
  computed: {
    currentStory () {
      if (!this.audios.length) return {}
      this.storyPlayState = false
      return this.audios[this.currentStoryIndex]
    },
    showIndicator () {
      return this.videos.length > 1 ? 'outside' : 'none'
    },
    showArrow () {
      return this.videos.length > 1 ? 'always' : 'never'
    }
  },
  watch: {
    currentStoryIndex () {
      this.totalAudioDuration = ''
    },
    videoPlayState (value) {
      this.modifyPlayState(value)
    }
  },
  methods: {
    carouselChange (newIndex, oldIndex) {
      const video = this.$refs.video[oldIndex]
      this.$nextTick(() => {
        this.videoPlayState = !video.paused
      })
      if (video) {
        video.pause()
      }
      this.currentCarouselIndex = newIndex
      this.watchVideoEnded(this.$refs.video[newIndex], this.$refs.video[oldIndex])
    },
    modifyPlayState (state) {
      if (state) {
        this.broadcastExclusivity(this.$refs.audio)
        this.storyPlayState = false
      }
    },
    handleEnded () {
      this.videoPlayState = false
    },
    watchVideoEnded (nv, ov) {
      if (ov) {
        ov.removeEventListener('ended', this.handleEnded)
      }
      if (nv) {
        nv.addEventListener('ended', this.handleEnded)
      }
    },
    setFacebookLink () {
        const URL = `https://www.facebook.com/sharer/sharer.php?u=${location.href}&display=popup&app_id=632378397093617`
        window.open(URL)
    },
    setTwitterLink (title) {
        const URL = `https://twitter.com/intent/tweet?text=${title}&url=${location.href}&via=cgtnenespanol`
        window.open(URL)
    },
    audioStartPlay () {
      const audio = this.$refs.audio
      if (audio) {
        if (audio.paused) {
          audio.play()
          this.broadcastExclusivity(this.$refs.video[this.currentCarouselIndex])
        } else {
          audio.pause()
        }
      }
      this.$nextTick(() => {
        this.storyPlayState = !audio.paused
      })
    },
    broadcastExclusivity (node) {
      this.$nextTick(() => {
        if (node) { 
          if (!node.paused) {
            node.pause()
            if (node instanceof HTMLVideoElement) {
              this.videoPlayState = false
            } else if (node instanceof HTMLAudioElement) {
              this.storyPlayState = false
            }
          }
        }
      })
    },
    forwardOrback (time) {
      const audio = this.$refs.audio
      if (audio) {
        if (!audio.paused) {
          audio.currentTime = audio.currentTime + time
        }
      }
    },
    nextOrPreviousEpisode (type) {
      if (type === 'previous' && this.currentStoryIndex !== 0) {
        this.currentStoryIndex -= 1
      } else if (type === 'next' && this.currentStoryIndex < this.audios.length - 1) {
        this.currentStoryIndex += 1
      }
    },
    playbackRate (rate) {
      const audio = this.$refs.audio
      if (audio) {
        if (!audio.paused) {
          audio.playbackRate = rate
          this.$nextTick(() => {
            this.speed = audio.playbackRate
          })
        }
      }
    },
    formatTime(seconds) {
      // 将秒转换为分钟和秒
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);

      // 使用 padStart 方法确保分钟和秒都是两位数
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(remainingSeconds).padStart(2, '0');

      // 返回格式化后的时间
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    audioLoadedmetadata (e) {
      this.totalAudioDuration = this.formatTime(e.target.duration)
    }
  },
}